import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./ada.png"
								alt="Apple Developer Academy"
								className="work-image"
							/>
							<div className="work-title">Apple Developer Academy</div>
							<div className="work-subtitle">
								iOS Developer & UI/UX Design
							</div>
							<div className="work-duration">2022 - 2023</div>
						</div>

						<div className="work">
							<img
								src="./itegra.png"
								alt="Itegra Tecnologia"
								className="work-image"
							/>
							<div className="work-title">Itegra Tecnologia</div>
							<div className="work-subtitle">
								Full-Stack Developer | Angular & Java
							</div>
							<div className="work-duration">2021</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
